import script from "./ListasSistemaCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./ListasSistemaCadastro.vue?vue&type=script&setup=true&lang=js"

import "./ListasSistemaCadastro.vue?vue&type=style&index=0&id=1a9fccd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a9fccd7"]])

export default __exports__